const equalHeight = () => {
    const comparisonBlock = document.querySelectorAll('.comparison-main');
    if(comparisonBlock) {
        function makeEqual() {
            for(let i=0; i < comparisonBlock.length; i++) {
                let result
                if(comparisonBlock[1].clientHeight < comparisonBlock[2].clientHeight) {
                    result = comparisonBlock[2].clientHeight;
                    comparisonBlock.forEach(item => {
                        item.style.height = `${result}px`
                    })
                } else {
                    result = comparisonBlock[1].clientHeight;
                    comparisonBlock.forEach(item => {
                        item.style.height = `${result}px`
                    })
                }
                
            }
        }
        makeEqual();
        window.addEventListener('resize',() => {
            comparisonBlock.forEach(item => {
                item.style.height = `auto`;
            })
            setTimeout(makeEqual, 100);

        }) 
        
    }
}

export default equalHeight;